angular.module('shared', [
  'ui.router',
  'angularCSS',
  'LocalStorageModule',
  'rails',
  'cleave.js',
  'data.country'
]);
